var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKenya({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_8145)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_8145",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_8145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 2.91699H1V23.3359H36V2.91699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 2.91699H1V9.04199H36V2.91699Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 17.2041H1V23.3291H36V17.2041Z",
    fill: "#2E6934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7061 19.1865L14.9248 19.3164L20.8789 8.99414C21.2275 8.89844 21.4189 8.57031 21.6104 8.23535C21.7402 8.0166 22.2461 7.12793 22.4717 5.97949C21.5898 6.74512 21.0771 7.62695 20.9541 7.85254C20.7627 8.1875 20.5713 8.51562 20.667 8.86426L14.7061 19.1865Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9317 19.3369L14.6924 19.2002L20.6397 8.85059C20.544 8.50879 20.7354 8.16699 20.9268 7.83887C21.4532 6.92285 22.0479 6.31445 22.4512 5.96582C22.376 6.50586 22.1436 7.32617 21.6172 8.24219C21.4258 8.57031 21.2344 8.91211 20.8789 9.00781L14.9317 19.3369ZM22.4512 5.97266C22.0752 6.33496 21.4873 6.94336 20.961 7.85254C20.7764 8.17383 20.585 8.50879 20.6739 8.85059L14.7198 19.1865L14.918 19.2822L20.8653 8.97363C21.2139 8.87109 21.4121 8.54297 21.5967 8.21484C22.1231 7.3125 22.3555 6.49902 22.4512 5.97266Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7061 19.1865L14.9248 19.3164L20.8789 8.99414C21.2275 8.89844 21.4189 8.57031 21.6104 8.23535C21.7402 8.0166 22.2461 7.12793 22.4717 5.97949C21.5898 6.74512 21.0771 7.62695 20.9541 7.85254C20.7627 8.1875 20.5713 8.51562 20.667 8.86426L14.7061 19.1865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9932 19.1865L21.7744 19.3164L15.8203 8.99414C15.4717 8.89844 15.2803 8.57031 15.0889 8.23535C14.959 8.0166 14.4531 7.12793 14.2275 5.97949C15.1094 6.74512 15.6221 7.62695 15.752 7.85254C15.9434 8.1875 16.1348 8.51562 16.0391 8.86426L21.9932 19.1865Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7676 19.3369L21.7608 19.3232L15.8067 9.00098C15.4649 8.91211 15.2666 8.57031 15.0752 8.24219C14.5489 7.32617 14.3164 6.50586 14.2139 5.97949C14.6446 6.31445 15.2393 6.92285 15.7657 7.83887C15.9571 8.16699 16.1485 8.50879 16.0596 8.86426L22.0137 19.1797L21.7676 19.3369ZM14.2139 5.98633C14.3438 6.49219 14.5694 7.30566 15.0957 8.22168C15.2803 8.54297 15.4717 8.87793 15.8135 8.97363L21.7813 19.2891L21.9864 19.1729L16.0254 8.87109C16.1143 8.51563 15.9229 8.18066 15.7383 7.85938C15.2119 6.94336 14.6172 6.3418 14.2139 5.98633Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9932 19.1865L21.7744 19.3164L15.8203 8.99414C15.4717 8.89844 15.2803 8.57031 15.0889 8.23535C14.959 8.0166 14.4531 7.12793 14.2275 5.97949C15.1094 6.74512 15.6221 7.62695 15.752 7.85254C15.9434 8.1875 16.1348 8.51562 16.0391 8.86426L21.9932 19.1865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 10.0605V16.1855H15.9297C16.3125 17.2041 17.584 19.248 18.3496 19.248C19.1152 19.248 20.3867 17.2041 20.7695 16.1855H36V10.0605H20.7695C20.3867 9.04199 19.1152 6.99805 18.3496 6.99805C17.584 6.99805 16.3125 9.04199 15.9297 10.0605H1Z",
    fill: "#AA1E23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7695 16.1855C21.1523 15.167 21.4052 14.1416 21.4052 13.123C21.4052 12.1045 21.1523 11.0791 20.7695 10.0605C20.3867 11.0791 20.1338 12.1045 20.1338 13.123C20.1338 14.1416 20.3867 15.167 20.7695 16.1855Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9297 16.1855C15.5469 15.167 15.2939 14.1416 15.2939 13.123C15.2939 12.1045 15.5469 11.0791 15.9297 10.0605C16.3125 11.0791 16.5654 12.1045 16.5654 13.123C16.5654 14.1416 16.3125 15.167 15.9297 16.1855Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3496 12.3574C18.6299 12.3574 18.8623 12.6992 18.8623 13.123C18.8623 13.5469 18.6367 13.8887 18.3496 13.8887C18.0694 13.8887 17.8369 13.5469 17.8369 13.123C17.8369 12.6992 18.0694 12.3574 18.3496 12.3574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4795 13.8682C18.4795 13.8682 18.9922 14.8867 18.9922 16.5479C18.9922 18.209 18.4795 19.2275 18.4795 19.2275V13.8682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2197 12.3779C18.2197 12.3779 17.707 11.3594 17.707 9.69824C17.707 8.03711 18.2197 7.01855 18.2197 7.01855V12.3779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2197 13.8682C18.2197 13.8682 17.707 14.8867 17.707 16.5479C17.707 18.209 18.2197 19.2275 18.2197 19.2275V13.8682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4795 12.3779C18.4795 12.3779 18.9922 11.3594 18.9922 9.69824C18.9922 8.03711 18.4795 7.01855 18.4795 7.01855V12.3779Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_8145",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_8145"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_8145",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenya);
export default __webpack_public_path__ + "static/media/Kenya.6442be59dfd44bf11eaa0a4a15c1154a.svg";
export { ForwardRef as ReactComponent };